/**
 * The words of the HR small features of 2026-10-10 (erp-sslab/human-resources#78): a loss that
 * closes custody, the violation notice as a document, a location's manager, a programme's work
 * location, withdrawing a swap, and recurring periodic incentives; then #80 (appraisal types, peer
 * feedback from self-service, attendance indicators) and #81 (the substitute day for the National
 * Day or Founding Day). Kept beside the catalogue, as the other HR rounds' words are, and spread into it.
 */
export const HR_SMALL_FEATURES_EN = {
    // erp-sslab/human-resources#81, human-resources-q7kt724v: the National Day or Founding Day on the weekly rest.
    "value.legal_reading.attendance.national_day_substitute": "National Day and Founding Day on the weekly rest are compensated",
};
export const HR_SMALL_FEATURES_AR = {
    "value.legal_reading.attendance.national_day_substitute": "تعويض اليوم الوطني ويوم التأسيس إذا وقعا في الراحة الأسبوعية",
};
//# sourceMappingURL=i18n-hr-small-features.js.map